export * from './app.strings';